<template>
  <div class="faq-section" ref="faqSection" v-click-outside="onClickOutside">
    <input type="checkbox" name id="faq-section" v-model="isOpen">
    <label for="faq-section" class="faq-section-label"><i class="bi bi-question"></i></label>
    <div class="faq-content">
      <div class="input-container">
        <input type="text" v-model="searchQuery" name="faq-search" id="faq-search" :placeholder="$t('FAQ_SEARCH')" />
      </div>
      <div class="faq-body">
        <div v-for="(item, key) in filteredFaqItems" :key="key" class="faq-item">
          <h3>{{ item.title }}</h3>
          <div v-html="item.description"></div>
        </div>
        <div v-if="filteredFaqItems.length === 0 && faqItems.length > 0" class="no-results">
          {{ $t('FAQ_NO_RESULTS') }}
        </div>
        <div v-if="loading" class="loading-indicator">
          {{ $t('FAQ_LOADING') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'FaqSection',
  data() {
    return {
      searchQuery: '',
      faqItems: [],
      loading: true,
      isOpen: false
    };
  },
  computed: {
    filteredFaqItems() {
      if (!this.searchQuery) {
        return this.faqItems;
      }
      
      const query = this.searchQuery.toLowerCase();
      return this.faqItems.filter(item => item.searchText.includes(query));
    }
  },
  mounted() {
    this.loadFaqTranslations();
  },
  methods: {
    onClickOutside() {
      this.isOpen = false;
    },
    // Descriptions are rendered as HTML, so search must run on the visible text only
    stripMarkup(html) {
      return html.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
    },
    async loadFaqTranslations() {
      try {
        // Dynamic import to lazy load the FAQ translations
        const faqModule = await import('@/translations/faq.js');
        const faqTranslations = faqModule.default;
        
        // Add FAQ translations to i18n
        Object.keys(this.$i18n.messages).forEach(locale => {
          if (locale in this.$i18n.messages) {
            // Extract translations for this locale
            const localeTranslations = {};
            Object.keys(faqTranslations).forEach(key => {
              if (faqTranslations[key][locale]) {
                localeTranslations[key] = faqTranslations[key][locale];
              } else if (faqTranslations[key]['en']) {
                // Fallback to English
                localeTranslations[key] = faqTranslations[key]['en'];
              }
            });
            
            // Merge translations
            if (Object.keys(localeTranslations).length > 0) {
              this.$i18n.mergeLocaleMessage(locale, localeTranslations);
            }
          }
        });
        
        this.processFaqTranslations(faqTranslations);
      } catch (error) {
        //console.error('Failed to load FAQ translations:', error);
      } finally {
        this.loading = false;
      }
    },
    processFaqTranslations(translations) {
      const faqItems = [];
      const currentLocale = this.$i18n.locale;
      const fallbackLocale = 'en';
      
      // Find all keys that end with _TITLE
      const titleKeys = Object.keys(translations).filter(key => key.endsWith('_TITLE'));
      
      titleKeys.forEach(titleKey => {
        const baseKey = titleKey.replace('_TITLE', '');
        const descKey = `${baseKey}_DESC`;
        
        // Skip if there's no matching description
        if (!translations[descKey]) return;
        
        // Get translation for current locale or fallback to English
        const title = (translations[titleKey][currentLocale] || translations[titleKey][fallbackLocale]);
        const description = (translations[descKey][currentLocale] || translations[descKey][fallbackLocale]);
        
        if (title && description) {
          faqItems.push({
            key: baseKey,
            title,
            description,
            searchText: `${title} ${this.stripMarkup(description)}`.toLowerCase()
          });
        }
      });
      
      this.faqItems = faqItems;
    }
  },
  directives: {
    ClickOutside
  }
}
</script>
